import { MasonryContentBlockRenderer } from '@leagueplatform/masonry-renderers';

export const RichTextContentBlockRenderer: typeof MasonryContentBlockRenderer =
  (
    { css, ...props }, // eslint-disable-line react/prop-types
  ) => (
    <MasonryContentBlockRenderer
      {...props}
      css={{
        ...css,
        display: 'flex',
        flexDirection: 'column',
        gap: '$half',
        '& .GDS-paragraph-text': {
          display: 'flex',
          flexDirection: 'column',
          gap: '$quarter',
          '& p:not(:last-child), & ul:not(:last-child)': {
            marginBlockEnd: '$half',
          },
        },
      }}
    />
  );
